import { BehaviorSubject, Observable } from 'rxjs';

export abstract class AbstractAuthService {
  abstract get currentUser(): string;
  abstract get currentUserLanId(): string;
  abstract get currentUserRoles(): string;
  abstract get isAuthenticated(): boolean;
  abstract get isLoggedOut(): boolean;
  abstract get shouldHaveSearchAccess(): boolean;
  abstract get accessToken(): string;
  abstract get isBpLoggedIn$(): BehaviorSubject<boolean>;
  abstract authenticateUser(): Observable<boolean>;
  abstract logout(): any;
}
